<template>
  <div class="profile-page">
    <!-- Header -->
    <div class="profile-header">
      <div class="avatar">
        <van-icon name="user-o" size="36" color="#6366f1" />
      </div>
      <div class="user-info">
        <div class="username">{{ user.username }}</div>
        <div class="user-role">{{ user.role === 'blogger' ? '博主' : '普通用户' }}</div>
      </div>
    </div>

    <!-- Stats -->
    <div class="stats-grid">
      <div class="stat-card" @click="$router.push('/orders')">
        <div class="stat-icon" style="background:#eef2ff">
          <van-icon name="orders-o" size="22" color="#6366f1" />
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ orderCount }}</div>
          <div class="stat-label">已购资源</div>
        </div>
      </div>
      <div class="stat-card" @click="$router.push('/following')">
        <div class="stat-icon" style="background:#fef3c7">
          <van-icon name="friends-o" size="22" color="#f59e0b" />
        </div>
        <div class="stat-info">
          <div class="stat-value">{{ followCount }}</div>
          <div class="stat-label">关注博主</div>
        </div>
      </div>
    </div>

    <!-- Menu -->
    <div class="menu-group">
      <van-cell
        title="我的已购" icon="orders-o" is-link
        to="/orders"
        label="查看已购资源和提取码"
      />
      <van-cell
        title="我的关注" icon="friends-o" is-link
        @click="$router.push('/following')"
        :label="followCount > 0 ? '已关注 ' + followCount + ' 位博主' : '关注你感兴趣的博主'"
      />
    </div>

    <div class="menu-group">
      <van-cell title="退出登录" icon="revoke" @click="onLogout" clickable>
        <template #title>
          <span style="color:#ef4444">退出登录</span>
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import { followApi, orderApi } from '../api';

export default {
  data() {
    return {
      followCount: 0,
      orderCount: 0
    };
  },
  computed: {
    user() { return this.$store.state.user || {}; }
  },
  created() { this.fetchData(); },
  methods: {
    async fetchData() {
      try {
        const [fcRes, ocRes] = await Promise.all([
          followApi.count(),
          orderApi.getMyOrders({ page: 1, size: 1 })
        ]);
        this.followCount = fcRes.data.count || 0;
        this.orderCount = ocRes.data.total || 0;
      } catch (e) { /* ignore */ }
    },
    onLogout() {
      this.$dialog.confirm({
        title: '退出登录',
        message: '确定要退出登录吗？'
      }).then(() => {
        this.$store.dispatch('logout');
        this.$router.replace('/login');
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.profile-page { min-height: 100vh; background: #f5f7fa; }
.profile-header {
  display: flex; align-items: center; gap: 16px;
  padding: 30px 20px;
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: #fff;
}
.avatar {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(255,255,255,0.95);
  display: flex; align-items: center; justify-content: center;
}
.username { font-size: 20px; font-weight: 700; }
.user-role { font-size: 13px; opacity: 0.8; margin-top: 4px; }
.stats-grid {
  display: flex; gap: 12px; margin: -16px 16px 16px;
  position: relative; z-index: 1;
}
.stat-card {
  flex: 1; display: flex; align-items: center; gap: 12px;
  background: #fff; border-radius: 14px; padding: 16px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.06);
  cursor: pointer;
}
.stat-icon {
  width: 44px; height: 44px; border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.stat-value { font-size: 18px; font-weight: 700; color: #1f2937; }
.stat-label { font-size: 12px; color: #9ca3af; margin-top: 2px; }
.menu-group {
  margin: 12px 16px; background: #fff;
  border-radius: 14px; overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
}
</style>
